{
  "labels": {
    "new_project": "New Project",
    "organization": "Organization",
    "private": "Private",
    "select_department": "Select Department",
    "cancel": "Cancel",
    "organizations": "Organizations",
    "departments": "Departments",
    "select_organization_from_left": "Select an organization",
    "org_does_not_have_deps": "This organization does not have any departments",
    "select_department_modal_title": "Select a Department",
    "this_project_belongs_to": "This project belongs to"
  },
  "input_labels": {
    "name": "Name",
    "description": "Description"
  },
  "templates": {
    "add_to_organization": "Add to {{organization}}"
  },
  "validation": {
    "name": {
      "empty": "Name is required",
      "duplicate_name": "Project with this name already exists",
      "min_length": "Min length of name is {{minLength}} characters",
      "max_length": "Max length of name is {{maxLength}} characters",
      "invalid": "Name should begin with a letter and end with a letter or digit. May include spaces, dots and dashes."
    },
    "description": {
      "max_length": "Max length of description is 200 characters",
      "empty": "Description is required"
    },
    "department": {
      "empty": "Department is required"
    }
  },
  "buttons": {
    "previous": "Previous",
    "next": "Next",
    "create": "Create"
  }
}
